import { render } from "./PerformerSceneList.vue?vue&type=template&id=22ded25a&ts=true"
import script from "./PerformerSceneList.vue?vue&type=script&lang=ts"
export * from "./PerformerSceneList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__